export default {
  CLEAR_FILTERS(state) {
    state.CLEAR_FILTERS = !state.CLEAR_FILTERS
  }
}
